export enum AccredibleKey {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SPACE = ' ',
  TAB = 'Tab',
  BACKSPACE = 'Backspace',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  HOME = 'Home',
  END = 'End',
}
